import { html, type TemplateResult } from 'lit';

export function iconPixelEye(size = 14): TemplateResult {
  return html`
    <svg
      width="${size}"
      height="${size}"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style="display: inline-block; vertical-align: middle;"
    >
      <!-- Outer eye contour -->
      <rect x="3" y="4" width="10" height="1" />
      <rect x="2" y="5" width="1" height="1" />
      <rect x="13" y="5" width="1" height="1" />
      <rect x="1" y="6" width="1" height="4" />
      <rect x="14" y="6" width="1" height="4" />
      <rect x="2" y="10" width="1" height="1" />
      <rect x="13" y="10" width="1" height="1" />
      <rect x="3" y="11" width="10" height="1" />
      <!-- Pupil -->
      <rect x="6" y="6" width="4" height="4" />
      <rect x="7" y="7" width="1" height="1" fill="#ffffff" />
    </svg>
  `;
}

export function iconPixelEyeOff(size = 14): TemplateResult {
  return html`
    <svg
      width="${size}"
      height="${size}"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style="display: inline-block; vertical-align: middle;"
    >
      <!-- Outer eye contour -->
      <rect x="3" y="4" width="10" height="1" />
      <rect x="2" y="5" width="1" height="1" />
      <rect x="13" y="5" width="1" height="1" />
      <rect x="1" y="6" width="1" height="4" />
      <rect x="14" y="6" width="1" height="4" />
      <rect x="2" y="10" width="1" height="1" />
      <rect x="13" y="10" width="1" height="1" />
      <rect x="3" y="11" width="10" height="1" />
      <!-- Pupil -->
      <rect x="6" y="6" width="4" height="4" />
      <!-- Slash line through eye -->
      <rect x="2" y="2" width="2" height="2" />
      <rect x="4" y="4" width="2" height="2" />
      <rect x="6" y="6" width="2" height="2" fill="#fafaf7" />
      <rect x="8" y="8" width="2" height="2" />
      <rect x="10" y="10" width="2" height="2" />
      <rect x="12" y="12" width="2" height="2" />
    </svg>
  `;
}
